import { Table } from '@shared/Table'
import React from 'react'
import { commentColumns as defaultCommentColumns } from '../../../../../constants/orderdetailhistory.columns'
import { useBusinessCardOrderDetailMutation } from '@app/store/reducers/salaryCards/businessCardOrder.api'

const OrderCommmetTable = () => {
  const [_, { data: detailInformationList, isSuccess }] =
    useBusinessCardOrderDetailMutation({
      fixedCacheKey: 'businessCardOrderDetail',
    })

  const commentColumns = defaultCommentColumns()
  
  const date = detailInformationList?.orderSalaryCardHistories?.find(
    (i) => i.acquiredStatus == detailInformationList?.status
  )?.actionDate
  
  const tableCommentData = [
    {
      date: detailInformationList?.description && date,
      comment: detailInformationList?.description,
    },
  ]

  return (
    <>
      <Table
        bordered
        editColumns={commentColumns}
        dataSource={isSuccess ? tableCommentData : []}
        size="small"
        pagination={false}
        tableKey={''}
      />
    </>
  )
}

export default OrderCommmetTable
